import React from 'react';
import { Container, Box } from '@hover/blueprint';
import { PROJECT_VISIONS } from '../../../constants';
import ProjectVision from './ProjectVision';
import { HeaderDescription } from '../../common';

const BringYourHomeProject: React.FC = () => (
  <Box w="100%" maxW="1200px" flexDir="column" alignItems="center">
    <HeaderDescription
      heading="Dream it. See it. Do it."
      body="Those photos don’t just turn out the most accurate measurements in the
        industry. They also create a 3D model of your actual home ready for you
        to style."
      maxWidth="4xl"
      mb={{ base: '72px', desktop: 1100 }}
    />
    <Container maxW="100%">
      {PROJECT_VISIONS.map(project => (
        <ProjectVision
          projectVision={project}
          key={project.id}
          reverse={project.id === 1}
          marginBottom={{
            base: PROJECT_VISIONS.length !== project.id + 1 ? '72px' : 1000,
            desktop: PROJECT_VISIONS.length === project.id + 1 ? 1100 : '152px',
          }}
        />
      ))}
    </Container>
  </Box>
);

export default BringYourHomeProject;
